export default "__VITE_ASSET__D45g0sDi__"